import React, { ReactElement, ReactNode } from 'react';
import Spinner from '../spinner';

interface WithLoadingProps {
  isLoading: boolean;
  children: ReactNode | ReactElement;
}

const LoadingCard: React.FC<WithLoadingProps> = ({
  isLoading = true,
  children,
}) => {
  return isLoading ? <Spinner /> : <>{children}</>;
};

export default LoadingCard;
